// Dev in the NEW-generation subscription "neurocare OS Dev" (Azure migration).
export const environment = {
  production: true,
  apiURL:
    'https://backend-4c01f830be5a-f7dpdwgxhsgbbwag.z03.azurefd.net/public-api',
  appInsights: {
    instrumentationKey: '76b2016a-32a8-427d-b2fc-69a3df8c56ff',
  },
  useAppInsights: true,
};
